module.exports = "pegasus/assets/themelp1/travel/107.png";